(() => {
  const drawer = document.getElementById('sa-cart-drawer');
  if (!drawer || !window.HTMLDialogElement || !drawer.showModal) return;
  const root = window.Shopify?.routes?.root || '/';
  const section = 'sa-cart-drawer';
  const status = drawer.querySelector('[data-sa-cart-status]');
  const errorBox = drawer.querySelector('[data-sa-cart-error]');
  let busy = false;
  let trigger;
  const content = () => drawer.querySelector('[data-sa-cart-content]');
  const message = (text = '') => { status.textContent = text; };
  const error = (text = '') => { errorBox.textContent = text; errorBox.hidden = !text; };
  const lock = value => {
    busy = value;
    drawer.setAttribute('aria-busy', String(value));
    content().inert = value;
  };
  const show = source => {
    if (source instanceof HTMLElement) trigger = source;
    if (!drawer.open) drawer.showModal();
  };
  const close = () => drawer.close();
  drawer.addEventListener('close', () => {
    if (trigger?.isConnected) trigger.focus({preventScroll: true});
  });
  drawer.addEventListener('click', event => {
    if (event.target !== drawer) return;
    const rect = drawer.getBoundingClientRect();
    if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
  });
  const render = html => {
    if (!html) throw new Error(drawer.dataset.error);
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const fresh = parsed.querySelector('[data-sa-cart-content]');
    if (!fresh) throw new Error(drawer.dataset.error);
    const scroll = content().querySelector('.sa-drawer__lines')?.scrollTop || 0;
    content().replaceWith(fresh);
    fresh.inert = busy;
    const lines = fresh.querySelector('.sa-drawer__lines');
    if (lines) lines.scrollTop = scroll;
    const count = fresh.dataset.count;
    drawer.querySelector('[data-sa-drawer-count]').textContent = count;
    document.querySelectorAll('.sap-header-cart span').forEach(badge => { badge.textContent = count; });
    document.dispatchEvent(new CustomEvent('sa:cart-updated', {detail: {itemCount: Number(count)}}));
  };
  const refresh = async () => {
    const url = new URL(root, location.origin);
    url.searchParams.set('section_id', section);
    const response = await fetch(url, {headers: {'Accept': 'text/html'}, cache: 'no-store'});
    if (!response.ok) throw new Error(drawer.dataset.error);
    render(await response.text());
  };
  const reconcile = async data => {
    if (data.sections?.[section]) render(data.sections[section]);
    else await refresh();
  };
  const open = async source => {
    show(source);
    if (busy) return;
    error(); message(drawer.dataset.loading); lock(true);
    try { await refresh(); message(); }
    catch { error(drawer.dataset.error); message(); }
    finally { lock(false); }
  };
  document.addEventListener('click', event => {
    const opener = event.target.closest('.sap-header-cart,[data-sa-cart-open]');
    if (opener && !event.metaKey && !event.ctrlKey && !event.shiftKey && event.button === 0) {
      event.preventDefault(); open(opener); return;
    }
    if (event.target.closest('[data-sa-cart-close]')) { close(); return; }
    const control = event.target.closest('[data-sa-cart-change]');
    if (!control || !drawer.contains(control) || event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    if (busy) return;
    change(control);
  });
  const change = async control => {
    const key = control.dataset.key;
    const operation = control.dataset.control;
    error(); message(drawer.dataset.loading); lock(true);
    try {
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: key, quantity: Number(control.dataset.quantity), sections: [section], sections_url: root})
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.description || data.message || drawer.dataset.error);
      await reconcile(data);
      message(drawer.dataset.updated);
    } catch (failure) {
      try { await refresh(); } catch {  }
      error(failure.message || drawer.dataset.error); message();
    } finally {
      lock(false);
      const next = Array.from(drawer.querySelectorAll('[data-sa-cart-change]')).find(el => el.dataset.key === key && el.dataset.control === operation);
      if (drawer.open) (next || drawer.querySelector('[data-sa-cart-close]')).focus({preventScroll: true});
    }
  };
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (drawer.contains(form)) {
      if (busy) event.preventDefault();
      return;
    }
    if (!form.matches('form.sa-direct-buy') || event.defaultPrevented) return;
    event.preventDefault();
    if (busy || !form.reportValidity()) return;
    const add = event.submitter || form.querySelector('[data-purchase-add]');
    if (add?.disabled) return;
    const data = new FormData(form);
    data.delete('return_to');
    data.set('sections', section); data.set('sections_url', root);
    const oldText = add?.textContent;
    if (add) { add.disabled = true; add.textContent = drawer.dataset.loading; }
    error(); message(drawer.dataset.loading); show(add); lock(true);
    let accepted = false;
    try {
      await refresh();
      const matching = Array.from(content().querySelectorAll('[data-sa-line]')).filter(line => line.dataset.variant === String(data.get('id')));
      const existing = matching.reduce((sum, line) => sum + Number(line.dataset.quantity), 0);
      const maximum = matching[0]?.dataset.max ?? form.querySelector('[name="quantity"]')?.getAttribute('max');
      if (maximum != null && maximum !== '' && existing + Number(data.get('quantity') || 1) > Number(maximum)) {
        error(drawer.dataset.stock); message(); return;
      }
      const response = await fetch(root + 'cart/add.js', {method: 'POST', headers: {'Accept': 'application/json'}, body: data});
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || drawer.dataset.error);
      accepted = true;
      await reconcile(result); message(drawer.dataset.added);
    } catch (failure) {
      try { await refresh(); } catch {  }
      error(accepted ? drawer.dataset.error : failure instanceof TypeError ? drawer.dataset.pending : failure.message || drawer.dataset.error);
      message();
    } finally {
      lock(false);
      if (add) { add.disabled = false; add.textContent = oldText; }
    }
  });
  window.addEventListener('pageshow', event => { if (event.persisted && drawer.open && !busy) open(); });
  window.SACart = {open, refresh};
})();
